import { createRouter, createWebHistory } from 'vue-router'
import LoginView     from '@/views/LoginView.vue'
import DashboardView from '@/views/DashboardView.vue'
import TasksView     from '@/views/TasksView.vue'
import ProjectsView  from '@/views/ProjectsView.vue'
import ArchiveView   from '@/views/ArchiveView.vue'
import TeamView      from '@/views/TeamView.vue'
import TeamDirectoryView from '@/views/TeamDirectoryView.vue'

const routes = [
  { path: '/login',    name: 'login',     component: LoginView,     meta: { public: true } },
  { path: '/',         name: 'dashboard', component: DashboardView },
  { path: '/tasks',    name: 'tasks',     component: TasksView },
  { path: '/projects', name: 'projects',  component: ProjectsView },
  { path: '/team',     name: 'team',      component: TeamDirectoryView, meta: { internalOnly: true } },
  { path: '/archive',  name: 'archive',   component: ArchiveView,  meta: { internalOnly: true } },
  { path: '/clients',  name: 'clients',   component: TeamView,     meta: { internalOnly: true } },
  { path: '/:catchAll(.*)', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const token = localStorage.getItem('todo_token')
  const user  = JSON.parse(localStorage.getItem('todo_user') || 'null')

  if (!to.meta.public && !token) {
    return { name: 'login' }
  }
  if (to.name === 'login' && token) {
    return { name: 'dashboard' }
  }
  if (to.meta.managerOnly && user?.role !== 'manager') {
    return { name: 'dashboard' }
  }
  if (to.meta.internalOnly && user?.user_type === 'external') {
    return { name: 'dashboard' }
  }
})

export default router
